import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { parseSeverityLevel, SeverityLevel } from "src/app/common/severity-level";

@Pipe({ name: 'severityLevel' })
  export class SeverityLevelPipe implements PipeTransform {
  
    constructor(private sanitizer: DomSanitizer) { }
  
    transform(value: unknown): SafeHtml {
      const level: SeverityLevel = parseSeverityLevel(value);
      let icon: string;
      let title: string;
  
      switch (level) {
    case SeverityLevel.Verbose:
      icon = 'fa fa-question-circle';
      title = 'Detaljeret';
      break;
    case SeverityLevel.Information:
      icon = 'fa fa-info-circle';
      title = 'Information';
      break;
    case SeverityLevel.Warning:
      icon = 'fa fa-exclamation-triangle';
      title = 'Advarsel';
      break;
    case SeverityLevel.Error:
      icon = 'fa fa-times-circle';
      title = 'Fejl';
      break;
    case SeverityLevel.Critical:
      icon = 'fa fa-heartbeat'; //not quite sure what icon to use here, would depend on what we deem as critical
      title = 'Kritisk';
      break;
    default:
      icon = 'fa fa-question-circle';
      title = 'Ukendt';
  }
  
      let html = `<i class="${icon}" title="${title}"></i>`;
      return this.sanitizer.bypassSecurityTrustHtml(html);
    }
  
  }